import { Button, useNotify, useRefresh } from "react-admin";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import { studentRequests } from "api/studentApi";

const StartRankingDialog = ({ campaignId }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleConfirm = async () => {
    await dataProvider.customRequest(
      studentRequests.startCurriculumSelectionCampaignRanking(campaignId),
      null,
      "POST",
    );
    notify("Класирането е стартирано успешно", { type: "success" });
    refresh();
  };

  return (
    <ConfirmModal
      titleContent="Стартирай класиране на кампания"
      message="Сигурни ли сте че искате да стартирате класиране за тази кампания?"
      onConfirm={handleConfirm}
      triggerButton={
        <Button
          label="Стартирай класиране на кампания"
          variant="contained"
          color="primary"
          startIcon={<PlayArrowIcon />}
        />
      }
    />
  );
};

export default StartRankingDialog;
